var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"title":"监管与服务"}}),_c('div',{ref:"echarts",staticClass:"echarts",style:({width: '820px', height: '380px'})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }